// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tm-left-col h1{margin-top:0px;margin-bottom:2rem}@media (min-width: 990px){.tm-left-col h1{margin-bottom:3.5rem}}.tm-left-col .tm-countryServiceBlock{display:none}.tm-left-col>div{display:flex;flex-direction:column;flex:1}@media(max-width:989px){.tow-columns-content.mb-flex-col-reverse{display:flex;flex-direction:column-reverse}.tm-left-col .tm-countryServiceBlock{display:block!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
